export const tableColumnTypes = {
  NUMBER: "NUMBER",
  STRING: "STRING",
  DATE: "DATE",
};
